<template>
  <div class="mockup">
    <div class="mockup__card mockup__container" v-if="!!current">
      <div class="mockup__header">
        <h1 class="mockup__header-title">{{ current.material }}</h1>

        <div class="mockup__btn-icon" @click="reset">
          <icon-cross />
        </div>

        <div class="mockup__btn-icon" @click="save">
          <icon-save />
        </div>

        <div
          class="mockup__btn-icon"
          :class="current.active ? 'mockup__btn-icon--active' : ''"
          @click="current.active = !current.active"
        >
          <icon-check v-if="current.active" />
        </div>

        <div
          class="mockup__btn mockup__btn"
          @click="current.addPreview('MockupPreviewDynamicModel')"
        >
          New Dynamic Mockup
        </div>
        <div
          class="mockup__btn mockup__btn"
          @click="current.addPreview('MockupPreviewImageModel')"
        >
          New Static Image Mockup
        </div>
        <div
          class="mockup__btn mockup__btn"
          @click="current.addPreview('MockupPreviewModel3d')"
        >
          New Model 3d
        </div>
        <div
          class="mockup__btn mockup__btn"
          @click="current.addPreview('MockupPreviewVideoModel')"
        >
          New Static Video Mockup
        </div>
        <div
          class="mockup__btn mockup__btn"
          @click="current.addPreview('MockupPreviewYoutubeVideoModel')"
        >
          New Youtube Video Mockup
        </div>
      </div>

      <div class="mockup__mockup-previews">
        <!-- mockupPreviews -->
        <div class="input-container">
          <label for="color" class="input-label">
            Cor do material
          </label>
          <div class="mockup__input-color">
            <span
              class="mockup__input-circle"
              :style="{ '--circle-color': `#` + current.color }"
            ></span>
            <the-mask
              mask="#FFFFFF"
              class="mockup__input-mask"
              :tokens="hexTokens"
              v-model="current.color"
              placeholder="Entre com o código de cor (hexadecimal)"
            />
          </div>
        </div>
        <mockup-preview
          v-for="(preview, i) in mockupPreviews"
          :key="i"
          :length="mockupPreviews.length"
          :current="preview"
          :colors="colors"
          @setColors="setColors"
          @addColor="addColor"
        >
          <template v-slot:order>
            <select class="mockup__select-order" v-model.number="preview.order">
              <option v-for="(item, o) in mockupPreviews" :key="o" :value="o">{{
                o
              }}</option>
            </select>
          </template>
        </mockup-preview>
      </div>
    </div>

    <template v-else>
      <mockup-select-material @output="init" />
      <mockup-list @output="init" />
    </template>
  </div>
</template>

<script>
import MockupSelectMaterial from "./mockup-select-material/MockupSelectMaterial.vue";
import MockupModel from "./MockupModel.js";
import MockupPreview from "./mockup-preview/MockupPreview.vue";
import MockupList from "./mockup-list/MockupList.vue";
import { TheMask } from "vue-the-mask";

import {
  getEditMockup,
  saveMockup,
} from "@/api/catalog-api/mockup-api/mockup.api.js";

import IconCheck from "@gocasebr/go-shared/dist/check/Check";
import IconSave from "@gocasebr/go-shared/dist/save/Save";
import IconCross from "@gocasebr/go-shared/dist/cross/Cross";

export default {
  name: "MockupComponent",
  components: {
    MockupSelectMaterial,
    MockupPreview,
    MockupList,
    IconSave,
    IconCheck,
    IconCross,
    TheMask,
  },
  data() {
    return {
      current: null,
      colors: [],
      hexTokens: {
        F: {
          pattern: /^[0-9a-fA-F]+$/,
          transform: (v) => (v = v.toLocaleLowerCase()),
        },
      },
    };
  },
  computed: {
    /* eslint-disable */
    mockupPreviews() {
      return !!this.current.mockupPreviews
        ? this.current.mockupPreviews.sort((a, b) => (a.order - b.order))
        : [];
    },
    /* eslint-enable */
  },
  methods: {
    addColor(c) {
      if (!c || !this.colors || this.colors.includes(c)) return;
      this.colors.push(c);
    },
    setColors(c) {
      this.colors = c;
    },
    init(material) {
      this.colors = [];
      getEditMockup(material)
        .then((res) => (this.current = new MockupModel(res)))
        .catch(() => (this.current = new MockupModel({ material })));
    },
    save() {
      console.log(this.current, "this.current");
      const currentJson = this.current.json();
      console.log(currentJson, "currentJson");
      saveMockup(currentJson)
        .then((res) => (this.current = new MockupModel(res)))
        .then(() => alert("saved"))
        .then(() => this.reset())
        .catch((err) => alert(err));
    },
    reset() {
      this.colors = [];
      this.current = null;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/variables.scss";

.mockup {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  .input-container {
    display: flex;
    align-items: center;
    border: 1px solid #f2f2f4;
    border-radius: 5px;
    background: #f2f2f4;
    padding: 0 6px 0 6px;
    margin: 6px;
  }

  .input-label {
    margin-right: 10px;
    font-size: 16px;
    color: #888;
    font-weight: 500;
  }

  &__input-color {
    margin: 6px 0;
    border: 1px solid #ec8ab3;
    border-radius: 4px;
    background-color: #fff;
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  &__input-circle {
    width: 24px;
    height: 24px;
    padding: 6px;
    margin-left: 6px;
    border-radius: 50%;
    border: 1.5px solid #f2f2f4;
    background-color: var(--circle-color);
  }

  &__input-mask {
    border: none;
    background: none;
    font-size: 16px;
    font-weight: 500;
    width: 100%;
    padding: 6px;
  }

  &__container {
    display: grid;
    grid-template-rows: auto 1fr;
    overflow: hidden;
    height: 100%;
  }

  &__mockup-previews {
    overflow: auto;
    height: 100%;
  }

  &--destroy {
    opacity: 0.2;
  }

  &__header {
    display: grid;
    grid-template-columns: auto auto auto auto 1fr 1fr 1fr;
    align-items: center;
    padding: 0 6px;
    gap: 6px;
  }

  &__header-title {
    margin: 0;
  }

  &__row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  &__card {
    padding: 6px;
  }

  &__input {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__btn {
    background-color: $sixth_color;
    border-radius: $border_radius;
    color: #fff;
    cursor: pointer;
    margin: 6px 0px;
    padding: 6px 20px;
    text-align: center;
    text-transform: uppercase;
    white-space: nowrap;
    user-select: none;
    flex: 1;

    &:hover {
      opacity: 0.5;
    }

    &--disabled {
      opacity: 0.5;
      cursor: no-drop;
    }
  }

  &__btn-icon {
    width: 33px;
    height: 33px;
    fill: #ec8ab3;
    border: 1px solid #ec8ab3;
    border-radius: 5px;
    padding: 6px;
    flex: none;
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }

    &--active {
      background: #ec8ab3;
      fill: #fff;
    }
  }

  &__select-order {
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .flex-1 {
    flex: 1;
  }
}
</style>
